import {FormInstance, Select} from 'antd';
import {useEffect} from 'react';

import {Locale} from '../../../../../../../../provider/locale/localization';
import {useFormRules} from '../../../../../../../../service/form/form-rules-hook';
import {usePostsInstagramPages} from '../../../../../../../../service/posts/posts-hooks';
import {PostFormFieldsEnum, PostFormType} from '../../../../../../../../service/posts/posts-types';
import {Form} from '../../../../../../../../typings/antd';
import {PostFormItemPropsType} from '../../../../post-form-type';

export function InstagramPagesItem(
    props: PostFormItemPropsType & {formInstance: FormInstance<PostFormType>}
): JSX.Element {
    const {disabled, formInstance} = props;

    const {requiredFieldRule} = useFormRules();

    const instagramIds = Form.useWatch<PostFormFieldsEnum.InstagramGroupsIds, FormInstance<PostFormType>>(
        PostFormFieldsEnum.InstagramGroupsIds,
        formInstance
    );

    const {data: availableInstagramPages, isLoading: isLoadingInstagramPages} = usePostsInstagramPages();

    useEffect(() => {
        if (instagramIds && !isLoadingInstagramPages) {
            const instagramPagesOptions: Array<string> = [];

            instagramIds.forEach((instagramId) => {
                if (availableInstagramPages?.map((instagramPage) => instagramPage.igId).includes(instagramId)) {
                    instagramPagesOptions.push(instagramId);
                }
            });
            formInstance.setFieldsValue({
                [PostFormFieldsEnum.InstagramGroupsIds]: instagramPagesOptions,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [availableInstagramPages, isLoadingInstagramPages, instagramIds]);

    return (
        <Form.Item<PostFormType>
            label={<Locale stringKey="POSTS_FORM__INSTAGRAM_PAGES__LABEL" />}
            name={PostFormFieldsEnum.InstagramGroupsIds}
            rules={[requiredFieldRule]}
        >
            <Select<Array<string>>
                disabled={disabled}
                loading={isLoadingInstagramPages}
                mode="multiple"
                optionFilterProp="children"
                placeholder={<Locale stringKey="POSTS_FORM__INSTAGRAM_PAGES__PLACEHOLDER" />}
            >
                {availableInstagramPages?.map((page) => (
                    <Select.Option key={page.igId} value={page.igId}>
                        {page.name}
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
    );
}
